
import React from 'react';
import { Clock } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface TimeRangeSelectorProps {
  startTime: string;
  endTime: string;
  scheduleId: string;
  onTimeChange: (scheduleId: string, field: 'startTime' | 'endTime', value: string) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ 
  startTime, 
  endTime, 
  scheduleId, 
  onTimeChange 
}) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 block">
          <Clock className="h-4 w-4 inline mr-1" />
          Start Time
        </label>
        <Input
          type="time"
          value={startTime}
          onChange={(e) => onTimeChange(scheduleId, 'startTime', e.target.value)}
          className="max-w-full"
        />
      </div>
      <div>
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 block">
          <Clock className="h-4 w-4 inline mr-1" />
          End Time
        </label>
        <Input
          type="time"
          value={endTime}
          onChange={(e) => onTimeChange(scheduleId, 'endTime', e.target.value)}
          className="max-w-full"
        />
      </div>
    </div>
  );
};

export default TimeRangeSelector;
